import React from 'react';
import { usePaymentSettings } from './presenter';
import { Button } from '../../../components/ui/Button';
import { Route } from '../../../components/layout/ProtectedLayout';

export type Props = {
  navigate: (r: Route) => void;
};

const PaymentSettingsViewOnlyPage: React.FC<Props> = ({ navigate }) => {
  const vm = usePaymentSettings();

  return (
    <div className="max-w-2xl">
      <h1 className="mb-4 text-xl font-semibold">Payment Settings</h1>
      {vm.loading && <div>Loading...</div>}
      {vm.error && <div className="text-sm text-destructive">{vm.error}</div>}
      {vm.data && (
        <div className="space-y-3">
          <div>
            <div className="text-sm text-muted-foreground">Provider</div>
            <div className="font-medium">{vm.data.provider}</div>
          </div>
          <div>
            <div className="text-sm text-muted-foreground">Environment</div>
            <div className="font-medium">{vm.data.environment}</div>
          </div>
          <div>
            <div className="text-sm text-muted-foreground">Merchant ID</div>
            <div className="font-mono">{vm.merchantId || '-'}</div>
          </div>
          <div>
            <div className="text-sm text-muted-foreground">API Base URL</div>
            <div className="font-mono">{vm.data.baseUrlApi ?? '-'}</div>
          </div>
          <div>
            <div className="text-sm text-muted-foreground">App Base URL</div>
            <div className="font-mono">{vm.data.baseUrlApp ?? '-'}</div>
          </div>
          <div>
            <div className="text-sm text-muted-foreground">Client Key</div>
            <div className="font-mono">{vm.data.clientKeyMasked ?? '-'}</div>
          </div>
          <div>
            <div className="text-sm text-muted-foreground">Server Key</div>
            <div className="font-mono">{vm.data.serverKeyMasked ?? '-'}</div>
          </div>
          <div className="text-xs text-muted-foreground">Last updated: {vm.data.updatedAt ? new Date(vm.data.updatedAt).toLocaleString() : '-'}</div>
        </div>
      )}
      <div className="mt-4 flex gap-2">
        <Button variant="outline" onClick={() => navigate({ name: 'settings/index' as any })}>Back</Button>
        <Button onClick={() => navigate({ name: 'settings/payment' as any })}>Edit</Button>
      </div>
    </div>
  );
};

export default PaymentSettingsViewOnlyPage;
